import { render, staticRenderFns } from "./UpdateUserInfo.vue?vue&type=template&id=45e80c8e&"
import script from "./UpdateUserInfo.vue?vue&type=script&lang=js&"
export * from "./UpdateUserInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports